<template>
  <amf-form :title="'Welcome, ' + userName">
    <div class="container-fluid">
      <div class="row">
        <div :is="roleDashboard" class="col-12"></div>
      </div>
    </div>
  </amf-form>
</template>

<script>
import AeDashboard from './AeDashboard.vue';
import MsrDashboard from './MsrDashboard.vue';
import MyEmployers from '../employer/MyEmployers.vue';
import DefaultDashboard from './DefaultDashboard.vue';
import ComplianceDashboard from './ComplianceDashboard.vue';
import EmployerDashboard from './EmployerDashboard.vue';
import FinanceDashboard from './FinanceDashboard.vue';
import AdminDashboard from './AdminDashboard.vue';

export default {
  components: { AeDashboard, MsrDashboard, DefaultDashboard, MyEmployers, ComplianceDashboard, EmployerDashboard, FinanceDashboard, AdminDashboard },
  data () {
    return {
    }
  },
  computed: {
    ...amfx.map("session", "user,userId,impersonatedUser,userRoles:roles,employers"),
    userName() {
        if (!this.user && !this.impersonatedUser) return '';
        if (this.impersonatedUser) {
            return `${this.impersonatedUser.firstName} ${this.impersonatedUser.lastName} (${this.user.fullName})`
        } else {
            return `${this.user.fullName}`
        }
    },
    roleDashboard() {
      const dashboards =
        [
          { type: "admin-dashboard", roles: ["admin"] },
          { type: "ae-dashboard", roles: ["ae"] },
          { type: "msr-dashboard", roles: ["msr"] },
          { type: "finance-dashboard", roles: ["finance"] },
          { type: "my-employers", roles: ["broker", "producersupport"] },
          { type: "compliance-dashboard", roles: ["compliance"] },
          { type: "employer-dashboard", roles: ["employer", "planadmin", "monthlyreporting", "invoicetotals", "invoicedetails", "cobracontact", "adminfeeinvoicing" ] }
        ];

      var roles = (this.impersonatedUser ? this.impersonatedUser.roles : this.userRoles) || [];

      roles = roles.map(r => r.toLowerCase());

      var dashboard = _.find(dashboards, dash => _.intersection(dash.roles, roles).length > 0);

      return (dashboard && dashboard.type) || "default-dashboard";
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/dashboards/MainDashboard.vue